import { inject, Injectable } from '@angular/core';
import { MatSnackBar, type MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CustomToastComponent, type SnackType } from './custom-toast.component';

export interface CustomToastOptions {
  message: string;
  snackType: SnackType;
  duration?: number;
  verticalPosition?: MatSnackBarVerticalPosition;
}

@Injectable({
  providedIn: 'root',
})
export class CustomToastService {
  private readonly snackBar = inject(MatSnackBar);

  public open({ message, snackType, duration, verticalPosition = 'top' }: CustomToastOptions) {
    return this.snackBar.openFromComponent(CustomToastComponent, {
      duration: duration ?? 3000,
      verticalPosition: verticalPosition || 'top',
      panelClass: snackType,
      data: { message, snackType },
    });
  }
}
